module.exports = __webpack_public_path__ + "img/6.f09ce430.png";